// @core/api/endpoints/bootstrap/test_oidc_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestOidcProviderRequest,
  TestOidcProviderResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Test OIDC provider
 * Fetches the OpenID Connect discovery document from the issuer URL and validates client credentials.
 * @public This endpoint does not require authentication
 */
export async function TestOidcProvider(
  data: TestOidcProviderRequest,
  options?: RequestOptions
): Promise<TestOidcProviderResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/security/test-oidc`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TestOidcProviderResponse>(requestPath, data, requestOptions);
}
